import { memo } from 'react';
import { Widowhood as WidowhoodVM } from 'mutation/view-models/registration-widowhood';
import {
  Divider,
  Grid,
  useEventCallback,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import ChooseDate from 'shell/components/shared/choice-date';
import { DatePickerView } from '@mui/lab/DatePicker/shared';
import { DateTime } from 'luxon';
import ItalianState from './italian-state';
import ForeignState from './foreign-state';
import { FormikTouched, FormikErrors } from 'formik';
import DocumentActForm from 'shell/components/shared/act';

interface FormProps {
  values?: WidowhoodVM | null;
  onChange: (key: keyof WidowhoodVM, value: WidowhoodVM[keyof WidowhoodVM]) => void;
  errors?: FormikErrors<WidowhoodVM>;
  touched?: FormikTouched<WidowhoodVM>;
  onChangeValues: (values: WidowhoodVM) => void;
}

const FormComponent = ({
  values,
  onChange,
  errors,
  touched,
  onChangeValues,
}: FormProps): React.ReactElement => {
  // Handle choice date
  const handleChooseDateChange = useEventCallback(
    (date: DateTime | null, choice?: Array<DatePickerView>) => {
      const newValues: WidowhoodVM = {
        eventDate: date,
        eventChoiceDate: choice,
      };

      onChangeValues(newValues);
    }
  );

  const onChangeRadio = useEventCallback(() => {
    const newValues: WidowhoodVM = {
      isForeign: !values?.isForeign,
      municipality: null,
      foreignState: null,
    };

    onChangeValues(newValues);
  });

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <PmiTextField
          label="Nr di matrimonio"
          aria-label="Nr di matrimonio"
          id="number"
          name="number"
          fullWidth
          onChange={(event) => {
            onChange('number', event?.target.value);
          }}
          value={values?.number || 0}
          type="number"
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Dati decesso del coniuge</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <ChooseDate
        required
        selected={values?.eventDate || null}
        onChange={handleChooseDateChange}
        choice={values?.eventChoiceDate}
        label="Data evento"
        error={Boolean(errors?.eventDate) && touched?.eventDate}
        helperText={errors?.eventDate}
      />
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Evento"
            id="isForeign"
            value={values?.isForeign || false}
            onChange={() => onChangeRadio()}
          >
            <FormControlLabel value="false" control={<Radio />} label="Evento Italia" />
            <FormControlLabel value="true" control={<Radio />} label="Evento Estero" />
          </RadioGroup>
        </FormControl>
      </Grid>
      {values?.isForeign ? (
        <ForeignState onChange={onChange} values={values} errors={errors} touched={touched} />
      ) : (
        <ItalianState
          fromDate={values?.eventDate}
          onChange={onChange}
          values={values}
          errors={errors}
          touched={touched}
        />
      )}
      {/* <Grid item xs={12} md={12}>
        <PmiTextField
          label="Luogo eccezionale *"
          aria-label="Luogo eccezionale"
          id="exceptionalPlace"
          name="exceptionalPlace"
          inputProps={{
            maxLength: '120',
          }}
          fullWidth
          value={values?.exceptionalPlace || ''}
          error={Boolean(errors?.exceptionalPlace) && touched?.exceptionalPlace}
          helperText={errors?.exceptionalPlace}
          onChange={(event) => onChange('exceptionalPlace', event.target.value)}
        />
      </Grid> */}
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Atto di morte</PmiTitleDivider>
      </Grid>
      <DocumentActForm
        values={values || undefined}
        onChange={onChange}
        onChanges={onChangeValues}
        touched={touched}
        errors={errors}
      />
    </Grid>
  );
};

FormComponent.displayName = 'Accordion Widowhood - Form component';

const Form = memo(FormComponent);

export default Form;
